/** @jsx jsx */
import { jsx } from 'theme-ui'
import { useColorMode } from 'theme-ui'
import { ThemeSwitch } from './'

export default props => {
    const [colorMode, setColorMode] = useColorMode()
    return (
        <button
            title="Change color mode"
            sx={{ variant: `buttons.transparent`, p: 1, borderRadius: `full`, ml: 4 }}
            onClick={e => {
                setColorMode(colorMode === 'light' ? 'dark' : 'light')
            }}>
            <ThemeSwitch />
        </button>
    )
}